import Colors from "@/styles/app.module.scss";
import i18n from "@/plugins/i18n";

function hexToRgba(hex, alpha) {
  const normalized = hex.replace("#", "");
  const chunkSize = normalized.length === 3 ? 1 : 2;
  const segments = normalized.match(new RegExp(`.{${chunkSize}}`, "g")) || [];
  const [r, g, b] = segments.map((segment) => {
    const value = chunkSize === 1 ? `${segment}${segment}` : segment;
    return Number.parseInt(value, 16);
  });

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function createTheme({ key, primary, secondary, heroIcon, toolbarImage }) {
  return {
    key,
    primary,
    secondary,
    surface: hexToRgba(primary, 0.06),
    surfaceAlt: hexToRgba(primary, 0.12),
    border: hexToRgba(primary, 0.18),
    heroIcon,
    toolbarImage,
    // Getter: o titulo acompanha o idioma escolhido.
    get membersTitle() {
      return i18n.t("common.classMembers");
    },
  };
}

export const classThemes = {
  customer: createTheme({
    key: "customer",
    primary: Colors["primary-500"],
    secondary: Colors["primary-600"],
    heroIcon: "mdi-school-outline",
    toolbarImage: require("@/assets/images/unsplash_aluno.webp"),
  }),
  partner: createTheme({
    key: "partner",
    primary: Colors["secondary-500"],
    secondary: Colors["secondary-600"],
    heroIcon: "mdi-book-open-page-variant-outline",
    toolbarImage: require("@/assets/images/unsplash_professor.webp"),
  }),
};
